// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'

import VueI18n from 'vue-i18n'
import store from './store.js'
import $ from 'jquery'
Vue.use(VueI18n)
console.log = function(){}
const i18n = new VueI18n({
  locale: 'zh', // 语言标识 
  messages: {
    'zh': require('./assets/lang/zh'),
    'en': require('./assets/lang/en')
  },
  silentTranslationWarn: true
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    if (document.getElementsByTagName('meta').length > 3) {
      head[0].removeChild($("[name|='keywords']")[0])
      head[0].removeChild($("[name|='description']")[0])
    }
    let meta = document.createElement('meta');
    let meta1 = document.createElement('meta');
    meta1.name = to.meta.name1;
    meta1.content = to.meta.content1;
    meta.name = to.meta.name;
    meta.content = to.meta.content;
    head[0].appendChild(meta1)
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
});


Vue.use(ElementUI);
// 使用VueLazyload并传入相应的配置

Vue.use(VueLazyload,{
  error:require('./assets/images/faction.png'),
  loading:require('./assets/images/faction.png')
})
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js